enum CallRequestTypeEnum {
    DATES = "DATES",
}

export default CallRequestTypeEnum;
